import { css } from '@lastbrand/web-ui-styled-system/css'

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'space-16',
  marginBlock: 'space-24',
})

export const adjustedPaddingForMobile = css({
  lgDown: {
    paddingRight: 'space-64',
  },
})

export const adjustedPaddingForMobile_noPaddingRight = css({
  lgDown: {
    paddingRight: 0,
  },
})

export const optionCard = css({
  display: 'flex',
  flexDirection: 'column',
  padding: 'space-16',
  border: '1px solid token(colors.lightgray)',
  borderRadius: 'radius-sm',
  cursor: 'pointer',
})

export const optionCardSelected = css({
  borderColor: 'black',
})

export const optionHeader = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'space-8',
})

export const priceContainer = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'space-4',
  marginLeft: 'auto',
})

export const strikethroughPrice = css({
  textStyle: 'body-16',
  fontWeight: 400,
  color: 'mediumgray',
  textDecoration: 'line-through',
})

export const currentPrice = css({
  textStyle: 'body-16',
  fontWeight: 400,
  color: 'black',
})

export const festivalOfferPrice = css({
  color: 'red-100',
})

export const radio = css({
  width: 'token(spacing.space-16)',
  height: 'token(spacing.space-16)',
  margin: 'space-2',
  cursor: 'pointer',
  appearance: 'none',
  WebkitAppearance: 'none',
  border: 'none',
  borderRadius: 'radius-round',
  position: 'relative',
  flexShrink: 0,
  backgroundColor: 'white',
  boxShadow: '0 0 0 1px token(colors.silvergray)',
  _checked: {
    boxShadow: '0 0 0 1px token(colors.black)',
    _after: {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 'token(spacing.space-10)',
      height: 'token(spacing.space-10)',
      borderRadius: 'radius-round',
      backgroundColor: 'black',
    },
  },
})

export const optionLabel = css({
  textStyle: 'body-14-strong',
})

export const expandedDetails = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'space-12',
  marginTop: 'space-12',
})

export const benefitItem = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'space-8',
  textStyle: 'body-12',
  fontWeight: 400,
})

export const iconWrapper = css({
  flexShrink: 0,
  alignSelf: 'flex-start',
  width: 'token(spacing.space-16)',
  height: 'token(spacing.space-16)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const iconImage = css({
  width: 'token(spacing.space-16)',
  height: 'token(spacing.space-16)',
  display: 'block',
  objectFit: 'contain',
  '& img': {
    objectFit: 'contain',
    width: 'full',
    height: 'full',
  },
})

export const iconPlaceholder = css({
  width: 'token(spacing.space-16)',
  textAlign: 'center',
})

export const savingsText = css({
  color: 'green-100',
  fontWeight: 400,
})

export const savingsTextPromo = css({
  color: 'red-100',
})

export const savingsTextPromoContinuation = css({
  color: 'black',
})

export const frequencyLink = css({
  textDecoration: 'underline',
  cursor: 'pointer',
  marginLeft: 'space-4',
  textUnderlineOffset: 'space-4',
})

// Shimmer placeholder shown while the active-inventory API resolves. Mirrors legacy `.shimmerWrapper`
// (same margin/gap as the real selector container); `adjustedPaddingForMobile*` above are reused as-is.
export const shimmerWrapper = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'space-16',
  marginBlock: 'space-24',
})
